import { collection, query, getCountFromServer } from 'firebase/firestore'
import { ref } from 'vue'
import firebase from '../../firebase'

const getCollectionDocumentsCount = (collectionName) => {
  const count = ref(0)

  const getDocumentsCount = async () => {
    const q = query(collection(firebase.db, collectionName))
    const s = await getCountFromServer(q)
    count.value = s.data().count
  }

  return { count, getDocumentsCount }
}
export default getCollectionDocumentsCount
